import React, { useEffect } from 'react';
import StatementCard from 'components/statement_card/statement_card.component';
import Footer from 'components/footer/footer.component';
import Header from 'components/header/header.component';
import Button from 'components/button/button.component';
import 'screens/user_screens/press_release.screen.scss';
import Pagination from 'react-js-pagination';
import Navbar from 'components/navbar/navbar.component';
import { getAllDetails } from 'models/public.model';
import moment from 'moment';
import { GET_STATEMENTS } from 'utils/types.utils';
import { useDispatch, useSelector } from 'react-redux';
import { throwError, useSetState } from '../../utils/common.utils';

export default function Press(props) {
  const dispatch = useDispatch();
  const statements = useSelector(
    (state: any) => state.announcements.statements,
  );
  const [state, setState] = useSetState({
    search: '',
    loading: true,
    page: 1,
    limit: 4,
    title: '',
    description: '',
    url: '',
  });
  const openPdf = (pdf) => {
    window.open(pdf);
  };
  const handlePageChange = (pageNumber) => {
    setState({ activePage: pageNumber, page: pageNumber });
  };
  const handleGetAllDetails = async () => {
    try {
      const data = {
        page: state.page,
        search: '',
        type: 'press',
        limit: state.limit,
      };
      const res: any = await getAllDetails(data);
      const details = res.data.docs.map((document) => {
        document.fileName = document.pdf[0].split('/').pop();
        document.date = moment(document.date).format('DD-MM-YYYY');
        return document;
      });
      res.data.docs = details;
      dispatch({
        type: GET_STATEMENTS,
        payload: res.data,
      });
    } catch (err:any) {
      throwError(
        err.data ? err.data.desc : 'Failed to get Press release details',
      );
    }
  };

  useEffect(() => {
    handleGetAllDetails();
  }, [state.page]);
  return (
    <div className="press_release_screen">
      <div className="press_release_container">
        <div className="press_release_wrapper">
          <div className="press_release_header_wrapper">
            <Header />
          </div>
          <div className="press_release_navbar_wrapper">
            <Navbar {...props} />
          </div>
          <div className="press_release_title_wrapper">
            <div className="press_release_title h2">Press Release</div>
            <div className="press_release_line_wrapper"> </div>
          </div>
          <div className="press_release_content_wrapper">
            <div className="press_release_content">
              {statements && statements.docs.map((statement) => {
                  return (
                    <div className="press_release_content_event_card">
                      <StatementCard
                        title={statement.title}
                        date={statement.date}
                        description={statement.description.length > 150 ? `${statement.description.substring(0, 235)}` : statement.description}
                        pdfName={statement.pdf}
                      />
                    </div>
                  );
                })}
            </div>
            <div className="pagination_wrapper">
              <div className="pagination">
                <Pagination
                  activePage={state.activePage}
                  activeLinkClass="link_active"
                  itemsCountPerPage={state.limit}
                  totalItemsCount={
                    statements && statements.totalDocs
                      ? statements.totalDocs
                      : 10
                  }
                  pageRangeDisplayed={6}
                  firstPageText="<<"
                  lastPageText=">>"
                  prevPageText="<"
                  nextPageText=">"
                  itemClassFirst="firstElement"
                  onChange={(e) => handlePageChange(e)}
                />
              </div>
            </div>
          </div>
          <div className="press_release_footer_wrapper">
            <div className="press_release_footer">
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
